import type { MarketVariants } from '@/lib/i18n'

export type Slide01Copy = {
  eyebrow: string
  title: string
  subtitle: string
  /** Alt text for the GranGuard mark (only rendered on the GranGuard face). */
  logoAlt: string
  /** Keyboard hint shown on wider screens. */
  keyboardTip: string
  /** Touch hint shown on small screens. */
  touchTip: string
}

export const copy: MarketVariants<Slide01Copy> = {
  US: {
    eyebrow: 'Chapter 1',
    title: 'The New Age of Scams',
    subtitle:
      "Before we learn to protect ourselves, we need to understand what we're up against.",
    logoAlt: 'GranGuard',
    keyboardTip: 'Tip: Arrow keys also work (← / →)',
    touchTip: 'Swipe or tap Continue',
  },
  ar: {
    eyebrow: 'الفصل 1',
    title: 'العصر الجديد للاحتيال',
    subtitle: 'قبل أن نتعلّم كيف نحمي أنفسنا، علينا أن نفهم ما نواجهه.',
    logoAlt: 'GranGuard',
    keyboardTip: 'تلميح: يمكنك أيضاً استخدام مفاتيح الأسهم (← / →)',
    touchTip: 'اسحب أو اضغط "متابعة"',
  },
}
